//Import Libraries
import React, { useEffect, useMemo } from "react";
import "bootstrap/dist/css/bootstrap.css";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useState } from "react";
import { withRouter } from "react-router";
import Button from "@material-ui/core/Button";
import { updateAlert, updateSourceInputs } from "../../../redux/actions";
import LayoutTopSideBottom from "../../../layouts/LayoutTopSideBottom/LayoutTopSideBottom";
import Breadcrumbs from "../../../components/Breadcrumbs/Breadcrumbs";
import EditableTableRetailer from "./EditableTable";
import fieldsArr from "../fields";
import "../rociview.scss";
import { config } from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import MetaSearchFilter from "./MetaSearchFilter";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { MetaData } from "./mockdata";
import EditAllModal from "../../../components/modal/EditAllModal";
import { useUserAuthentication } from "../../../utils/utils";
import { ApprovalButton } from "../../../components/Approval/ApprovalButton";
import { ApprovalTable } from "../../../components/Approval/ApprovalTable";
import { useHistory } from "react-router-dom";
import DynamicDialog from "../../../components/Dialog/Dialog";

let api = config.api.api_url;
// let api = process.env.REACT_APP_BACKEND_BASE_URL;

function RGMRetailView(props) {
  const { user, match, updateSourceInputs, updateAlert, source_data } = props;

  // STATES
  const [loading, setLoading] = useState(true);
  const [tableLoading, setTableLoading] = useState(true);
  const [isTableDataSaving, setIsTableDataSaving] = useState(false);
  const [isSearchFilterLoading, setIsSearchFilterLoading] = useState(false);
  const [initial, setInitial] = useState(true);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [isEdit, setIsEdit] = useState(false);
  const [globalEdit, setGlobalEdit] = useState(false);
  const [isFileUploading, setIsFileUploading] = useState(false);
  const [isSaveDialogOpen, setIsSaveDialogOpen] = useState(false);
  const [isCancelDialogOpen, setIsCancelDialogOpen] = useState(false);
  const [isEditAllModelOpen, setIsEditAllModalOpen] = useState(false);
  const [isApproval, setIsApproval] = useState(false);
  const [isDynamicDialogOpen, setIsDynamicDialogOpen] = useState(false);
  const [dynamicDialogMessage, setDynamicDialogMessage] = useState();

  let history = useHistory();

  const { login } = useUserAuthentication();

  // FUNCTIONS
  const moveBannerToLast = (arr) => {
    const bannerItem = arr.find((item) => item.name === "BANNER");
    const TradeTypeItem = arr.find((item) => item.name === "TRADE_TYPE_DESC");
    if (!bannerItem) return arr;

    // Filter out the banner and push it to the end
    const filtered = arr.filter(
      (item) => item.name !== "BANNER" && item.name !== "TRADE_TYPE_DESC",
    );
    return [...filtered, TradeTypeItem, bannerItem];
  };

  const clearReduxState = () => {
    updateSourceInputs("has_awaiting_data", false);
    updateSourceInputs("data", []);
    updateSourceInputs("checked_rows_count", 0);
    updateSourceInputs("current_bussines_unit", "");
    updateSourceInputs("current_dimension", {});
    updateSourceInputs("dimensions_list", []);
    updateSourceInputs("current_source", "");
    updateSourceInputs("current_source_label", "");
    updateSourceInputs("current_target_gold_layer", "");
    updateSourceInputs("current_country", "");
    updateSourceInputs("current_country_code", "");
    updateSourceInputs("current_cmu", "");
    updateSourceInputs("current_category", "");
    updateSourceInputs("current_ssfFileId", "");
    updateSourceInputs("current_filter_value", "");
    updateSourceInputs("current_template_filter_value", "");
    updateSourceInputs("current_template_ssfFileId", "");
    updateSourceInputs("current_table_name", "");
    updateSourceInputs("is_initial", true);
    updateSourceInputs("is_table_loading", true);
    updateSourceInputs("searchValue", "");
    updateSourceInputs("any_row_isEditing", false);
    updateSourceInputs("isFileUploaded", false);
    updateSourceInputs("isNewDataInserted", false);
    updateSourceInputs("current_bussines_unit_list", []);
    updateSourceInputs("current_mapped_source", []);
    updateSourceInputs("current_target_gold_layer_list", []);
    updateSourceInputs("current_mapped_country", []);
    updateSourceInputs("master_table_countries", []);
    updateSourceInputs("current_ssf_file_id", []);
    updateSourceInputs("current_template_ssf_file_id", []);
    updateSourceInputs("current_category_data", []);
    updateSourceInputs("current_mapped_data", []);
    updateSourceInputs("current_mapped_data_main", []);
    updateSourceInputs("modified_mapped_data", []);
    updateSourceInputs("current_filters", []);
    updateSourceInputs("appliedFilters", []);
    updateSourceInputs("download_sample_file", []);
    updateSourceInputs("filtered_Rows", []);
    updateSourceInputs("current_columns", []);
    updateSourceInputs("actualData", []);
    updateSourceInputs("recommendedModel", []);
    updateSourceInputs("approvalData", []);
    updateSourceInputs("approvalTable_Header", []);
  };

  async function getSources() {
    const params = new URLSearchParams({
      dataset_name: "RGM_retailer_mapping_metadata",
    });
    try {
      // code for initial data fetching
      const response = await fetch(
        api + `/rgm_retailer_mapping/getmetadata?${params}`,
        {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
        },
      );

      const jsonData = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (jsonData?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      if (!jsonData || !jsonData.data) {
        throw new Error("Unexpected error occured. Please try again later");
      }
      const responseData = jsonData.data;

      const { MRA_L1_BU, fetch_filter, ...rest } = responseData;

      const Bussines_Unit = MRA_L1_BU.map((item) => ({
        label: item,
        value: item,
      }));

      const FILTERS = fetch_filter.map((filter) => ({
        label: filter,
        value: filter,
      }));

      const Edit_Column_List = moveBannerToLast(rest.edit_model_column_list);

      const Table_Header_Column_List = moveBannerToLast(
        rest.table_header_column_list,
      );

      updateSourceInputs("current_bussines_unit_list", Bussines_Unit);
      updateSourceInputs("current_filters", FILTERS);
      updateSourceInputs("data", {
        dropdown: {
          ...rest,
          edit_model_column_list: Edit_Column_List,
          table_header_column_list: Table_Header_Column_List,
        },
      });
    } catch (err) {
      updateAlert({
        open: true,
        message: `Unexpected error occured. Please try again later`,
        severity: "Failed",
        closeFlag: true,
      });
    } finally {
      setLoading(false);
    }
  }

  const getData = (row) => {};

  const outlinedCNCButton = {
    borderColor: "#46596A",
    // background-color: #d7dadd,
    color: "#46596A",
    // width: '100%',
    fontFamily: "Hind Siliguri",
    fontSize: "12px",
    fontWeight: "bold",
    marginRight: "5px",
  };

  const containedButton = {
    color: "white",
    backgroundColor: "#46596A",
    fontFamily: "Hind Siliguri",
    fontSize: "12px",
    fontWeight: "bold",
    // marginLeft: "10px !important",
    marginRight: "5px",
  };

  const IS_ANY_ROWDATA_NULL = useMemo(() => {
    if (
      source_data.current_mapped_data &&
      source_data.current_mapped_data.length > 0 &&
      source_data.data.dropdown
    ) {
      const ExceptionKeys = Array.isArray(
        source_data.data.dropdown.metadata_filter,
      )
        ? [...source_data.data.dropdown.metadata_filter]
        : [];

      return source_data.current_mapped_data.some((singleRowData) => {
        const rowData = singleRowData?.rowData || {};
        return Object.keys(rowData).every(
          (key) => ExceptionKeys.includes(key) || rowData[key] === null,
        );
      });
    } else {
      return false;
    }
  }, [
    source_data.current_mapped_data,
    source_data.current_ssfFileId,
    source_data.current_filter_value,
  ]);

  const is_Approver = useMemo(() => {
    const Is_Role_Approver = user?.role && user?.role?.includes("AppApprover");
    const URL = history?.location?.pathname || [];
    const result = URL.split("/").pop();
    const is_Approver_For_This_Usecase =
      user?.approval_screens && user?.approval_screens?.includes(result);
    return Is_Role_Approver && is_Approver_For_This_Usecase;
  }, [user.role, user.approval_screens]);

  //function to set page for changing table row
  const pageChange = (event, value) => {
    setPage(value);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  let page_props = {
    total: source_data.current_mapped_data
      ? Math.ceil(source_data.current_mapped_data.length / rowsPerPage)
      : 0,
    page: page,
    changePage: pageChange,
    rowsPerPage: rowsPerPage,
    handleChangeRowsPerPage: handleChangeRowsPerPage,
    show_pageOptions: true,
  };

  function cancelFunction() {
    setIsCancelDialogOpen(false);
    updateSourceInputs("current_bussines_unit", "");
    updateSourceInputs("current_source", "");
    updateSourceInputs("current_country", "");
    updateSourceInputs("current_country_code", "");
    updateSourceInputs("current_table_name", "");
    updateSourceInputs("current_bussines_unit_list", []);
    updateSourceInputs("current_mapped_country", []);
    updateSourceInputs("current_mapped_data", []);
    updateSourceInputs("current_filter_value", "");
    updateSourceInputs("modified_mapped_data", []);
    updateSourceInputs("any_row_isEditing", false);
    setInitial(true);
    updateSourceInputs("is_initial", true);
    getSources();
  }

  function mergeWithObj2Priority(obj1, obj2) {
    const commonKeys = Object.keys(obj1).filter((key) => key in obj2);

    if (commonKeys.length > 0) {
      // Merge and overwrite obj1 values with obj2 values for common keys
      return {
        ...obj1,
        ...obj2, // obj2 values take priority
      };
    } else {
      // No common keys – just merge all keys
      return {
        ...obj1,
        ...obj2,
      };
    }
  }

  // Function with Mock Data for Calculated Expression validation Flow
  const onSave = async () => {
    setIsTableDataSaving(true);

    // Getting The MODIFIED_MAPPED_DATA with IS_EDITED ATTRIBUTE
    const MODIFIED_MAPPED_DATA = source_data.modified_mapped_data.map(
      (item) => {
        const banner = item.rowData["BANNER"];
        const isProperValue =
          banner &&
          typeof banner === "string" &&
          item.rowData["BANNER"].toLowerCase() !== "null" &&
          item.rowData["BANNER"].toLowerCase() !== "unmapped";

        const Sorted_RowData = {
          ...item.rowData,
          BANNER_STATUS: isProperValue ? "MAPPED" : "UNMAPPED",
          UPDATED_BY: user.mail || "Harbor-app-test",
        };

        return Sorted_RowData;
      },
    );

    const params = new URLSearchParams({
      dataset_name: "RGM_retailer_mapping",
      MRA_L1_BU: source_data?.current_bussines_unit || "",
      MRA_L5: source_data?.current_country || "",
      userid: user?.mail || "",
    });

    try {
      const response = await fetch(
        api + `/rgm_retailer_mapping/updatetabledata?${params}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(MODIFIED_MAPPED_DATA),
          credentials: "include",
        },
      );

      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      if (data.statusCode === "harbor-200") {
        clearReduxState();
        getSources();
        setInitial(true);
        setGlobalEdit(false);
        setTableLoading(false);

        // Toast OnSuccess
        updateAlert({
          open: true,
          message: "All the changes are saved successfully",
          severity: "success",
          closeFlag: true,
        });
      }
    } catch (err) {
      updateAlert({
        open: true,
        message: `Unexpected error occured. Please try again later`,
        severity: "Failed ",
        closeFlag: true,
      });
      setIsTableDataSaving(false);
      setIsSaveDialogOpen(false);
    }

    setIsTableDataSaving(false);
    setIsSaveDialogOpen(false);
  };

  {
    /* Enable this code if approval needed start ==========> */
  }
  // const onSaveAwaitingData = async () => {
  //   setIsTableDataSaving(true);

  //   // Getting The MODIFIED_MAPPED_DATA with IS_EDITED ATTRIBUTE
  //   const MODIFIED_MAPPED_DATA = source_data.modified_mapped_data.map(
  //     (item) => {
  //       const banner = item.rowData["BANNER"];
  //       const isProperValue =
  //         banner &&
  //         typeof banner === "string" &&
  //         item.rowData["BANNER"].toLowerCase() !== "null" &&
  //         item.rowData["BANNER"].toLowerCase() !== "unmapped";

  //       const Sorted_RowData = {
  //         ...item.rowData,
  //         BANNER_STATUS: isProperValue ? "MAPPED" : "UNMAPPED",
  //         UPDATED_BY: user.mail || "Harbor-app-test",
  //       };

  //       return Sorted_RowData;
  //     }
  //   );

  //   try {
  //     const params = new URLSearchParams({
  //       dataset_name: "RGM_retailer_mapping",
  //       MRA_L1_BU: source_data?.current_bussines_unit || "",
  //       MRA_L5: source_data?.current_country || "",
  //       userid: user?.mail || "",
  //     });

  //     const response = await fetch(
  //       api + `/rgm_retailer_mapping/update_awaiting_data?${params}`,
  //       {
  //         method: "POST",
  //         headers: {
  //           Authorization: `Bearer ${user.token || ""}`,
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify(MODIFIED_MAPPED_DATA),
  //         credentials: "include",
  //       }
  //     );

  //     const data = await response.json();

  //     // Check if response is OK before trying to parse it
  //     if (!response.ok) {
  //       if (data?.statusCode === "harbor-401") {
  //         updateAlert({
  //           open: true,
  //           message: `User Unauthorized. Please sign in.`,
  //           severity: "warning",
  //           closeFlag: true,
  //         });
  //         login(); // or redirect to login
  //         return;
  //       } else {
  //         throw new Error(
  //           `Got an error: ${data?.message}` || `API error: ${response.status}`
  //         );
  //       }
  //     }

  //     // Check response for successful DB update
  //     if (data.statusCode === "harbor-200") {
  //       clearReduxState();
  //       getSources();
  //       setInitial(true);
  //       setGlobalEdit(false);
  //       setTableLoading(false);

  //       // Toast OnSuccess
  //       updateAlert({
  //         open: true,
  //         message: "All the changes are saved & awaiting for approval",
  //         severity: "success",
  //         closeFlag: true,
  //       });
  //     }
  //   } catch (err) {
  //     updateAlert({
  //       open: true,
  //       message: err
  //         ? `API called Failed. Error: ${err.message || err}`
  //         : `Got an error in the API call. Please check`,
  //       severity: "Failed ",
  //       closeFlag: true,
  //     });
  //     setIsTableDataSaving(false);
  //     setIsSaveDialogOpen(false);
  //   }

  //   setIsTableDataSaving(false);
  //   setIsSaveDialogOpen(false);
  // };

  {
    /* Enable this code if approval needed end ==========> */
  }

  const setMappedData = async (dataset, country, filter) => {
    setInitial(false);
    updateSourceInputs("is_initial", false);
    setGlobalEdit(false);
    setTableLoading(true);
    updateSourceInputs("is_table_loading", true);
    setIsSearchFilterLoading(true);

    let filteredDatasetValue;
    let tableData;
    // let have_awaiting_records = {}; Enable this code if approval needed start ==========>

    // const Meta_Filters = source_data.data.dropdown.metadata_filter;
    const params = new URLSearchParams({
      dataset_name: "RGM_retailer_mapping",
      MRA_L1_BU: source_data?.current_bussines_unit || "",
      MRA_L5: source_data?.current_country || "",
      fetch_type: dataset && dataset.length > 0 ? dataset.toLowerCase() : "all",
      userid: user?.mail || "",
    });

    try {
      const response = await fetch(
        api + `/rgm_retailer_mapping/fetchtabledata?${params}`,
        {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
        },
      );
      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      if (!data || !data.data) {
        throw new Error("Unexpected error occured. Please try again later");
      }

      if (data && data.data) {
        filteredDatasetValue = data.data;

        {
          /* Enable this code if approval needed start ==========> */
        }
        // const DATA = data.data[0];
        // have_awaiting_records = {
        //   has_records: data.awaiting_data_present || false,
        //   has_access: data.statusCode === "harbor-201" ? true : false,
        //   editor: DATA?.username || "",
        //   approver: DATA?.approver || "",
        // };
        // updateSourceInputs("has_awaiting_data", have_awaiting_records);
        {
          /* Enable this code if approval needed end ==========> */
        }
      }
    } catch (err) {
      updateAlert({
        open: true,
        message: `Unexpected error occured. Please try again later`,
        severity: "Failed ",
        closeFlag: true,
      });
      setLoading(false);
      setTableLoading(false);
      updateSourceInputs("is_table_loading", false);
      setIsSearchFilterLoading(false);
      return;
    }

    let val = filteredDatasetValue;
    let ITEM_ID = 0;
    tableData =
      val &&
      val.map((item) => {
        const rowData = {
          item_Id: ITEM_ID,
          isEditing: false,
          isNewData: false,
          isEdited: false,
          isValidated: true,
          isCheckedRow: false,
          errorMessage: "",
          rowData: item,
        };
        ITEM_ID++;
        return rowData;
      });

    // TABLE_DROPDOWN_DATA
    {
      /* Enable this code if approval needed start ==========> */
    }
    // if (have_awaiting_records.has_records) {
    //   setIsDynamicDialogOpen(true);
    //   setDynamicDialogMessage(
    //     have_awaiting_records.has_access
    //       ? "Your awaiting data available for this file_Id, Do you want to fetch ?"
    //       : `Awaiting data available for this SFF_File_Id. ${
    //           `${have_awaiting_records?.editor} ${
    //             have_awaiting_records?.editor.length > 1 ? "are" : "is"
    //           } ` || ""
    //         } the ${
    //           have_awaiting_records?.editor.length > 1 ? "editors" : "editor"
    //         } and ${
    //           `${have_awaiting_records?.approver} ${
    //             have_awaiting_records?.approver.length > 1 ? "are" : "is"
    //           } ` || ""
    //         } the ${
    //           have_awaiting_records?.approver.length > 1
    //             ? "approvers"
    //             : "approver"
    //         }. Kindly contact them for further assistance`
    //   );
    // } else {
    //   updateSourceInputs("current_mapped_data", tableData);
    //   setLoading(false);
    //   setTableLoading(false);
    //   updateSourceInputs("is_table_loading", false);
    //   setIsSearchFilterLoading(false);
    // }
    {
      /* Enable this code if approval needed end ==========> */
    }

    updateSourceInputs("current_mapped_data", tableData);
    setLoading(false);
    setTableLoading(false);
    updateSourceInputs("is_table_loading", false);
    setIsSearchFilterLoading(false);
  };

  const fetchAwaitingRecords = async () => {
    setIsDynamicDialogOpen(false);

    let filteredDatasetValue;
    try {
      const params = new URLSearchParams({
        dataset_name: "RGM_retailer_mapping",
        MRA_L1_BU: source_data?.current_bussines_unit || "",
        MRA_L5: source_data?.current_country || "",
        userid: user.mail || "",
      });

      const response = await fetch(
        api + `/rgm_retailer_mapping/fetch_awaiting_data?${params}`,
        {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
        },
      );

      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      if (!data || !data.data) {
        throw new Error("Unexpected error occured. Please try again later");
      }

      if (source_data?.data?.dropdown?.is_value_fetch) {
        const VALUES_WITHOUT_NULL = Array.isArray(data.values_data)
          ? data.values_data.filter(
              (item) =>
                item !== null &&
                item !== "null" &&
                item !== "" &&
                item !== undefined,
            )
          : [];
        const UPDATED_DROPDOWN_DATA = {
          ...source_data.data,
          dropdown: {
            ...source_data.data.dropdown,
            HARBOR_VALUE: VALUES_WITHOUT_NULL,
          },
        };

        updateSourceInputs("data", UPDATED_DROPDOWN_DATA);
      }

      if (data && data.data) {
        filteredDatasetValue = data.data;
      }

      // DownloadSampleData = data?.sample_data || [];
    } catch (err) {
      updateAlert({
        open: true,
        message: "Unexpected error occured. Please try again later",
        severity: "Failed ",
        closeFlag: true,
      });
      setLoading(false);
      setTableLoading(false);
      updateSourceInputs("is_table_loading", false);
      setIsSearchFilterLoading(false);
      return;
    }

    let val = filteredDatasetValue;
    let ITEM_ID = 0;
    const tableData =
      val &&
      val.map((item) => {
        const rowData = {
          item_Id: ITEM_ID,
          isEditing: false,
          isNewData: false,
          isEdited: false,
          isValidated: true,
          isCheckedRow: false,
          errorMessage: "",
          rowData: item,
        };
        ITEM_ID++;
        return rowData;
      });

    // TABLE_DROPDOWN_DATA
    updateSourceInputs("current_mapped_data", tableData);
    updateSourceInputs("current_mapped_data_main", tableData);

    updateSourceInputs("is_table_loading", false);
    setLoading(false);
    setTableLoading(false);
    setIsSearchFilterLoading(false);
  };

  const setMappedDataCreateNew = async (dataset, country, filter) => {
    setInitial(false);
    updateSourceInputs("is_initial", false);
    setGlobalEdit(false);
    setTableLoading(true);
    updateSourceInputs("is_table_loading", true);
    setIsSearchFilterLoading(true);

    let tableData;

    // const Meta_Filters = source_data.data.dropdown.metadata_filter;
    const params = new URLSearchParams({
      dataset_name: "New_retailer_mapping",
    });

    let InsertNewTableData;
    try {
      const response = await fetch(
        api + `/retailer_mapping/getmetadata?${params}`,
        {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
        },
      );
      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }
      if (data && data.data) {
        InsertNewTableData = data.data;
      }

      const val = InsertNewTableData.New_retailer_mapping;
      let ITEM_ID = 0;
      tableData =
        val &&
        val.map((item) => {
          const rowData = {
            item_Id: ITEM_ID,
            isEditing: false,
            isNewData: false,
            isEdited: false,
            isValidated: true,
            isCheckedRow: false,
            errorMessage: "",
            rowData: {
              COUNTRY: source_data.current_country,
              COUNTRY_CODE: source_data.current_country_code,
              ...item,
              SOURCE: source_data.current_source,
            },
          };
          ITEM_ID++;
          return rowData;
        });

      const MODIFIED_MAPPED_DATA = tableData.map((rowData) => {
        return {
          actual: {},
          updated: rowData,
        };
      });
      updateSourceInputs("modified_mapped_data", MODIFIED_MAPPED_DATA);
    } catch (err) {
      updateAlert({
        open: true,
        message: `Unexpected error occured. Please try again later`,
        severity: "Failed ",
        closeFlag: true,
      });
    }

    // TABLE_DROPDOWN_DATA
    updateSourceInputs("current_mapped_data", tableData);
    setLoading(false);
    setTableLoading(false);
    updateSourceInputs("is_table_loading", false);
    setIsSearchFilterLoading(false);
  };

  const handleSourceInput = (data, selectedRowsCount) => {
    updateSourceInputs("current_mapped_data", data);
    updateSourceInputs("checked_rows_count", selectedRowsCount);
  };

  const handleValidateFileData = (tableData) => {
    updateAlert({
      open: true,
      message: "Validating row data's",
      severity: "success",
      closeFlag: true,
    });

    const Current_Table_Data = tableData;
    const TABLE_HEAD_COLUMN_LIST =
      source_data.data.dropdown.table_header_column_list;
    const EDIT_COLUMN_LIST = source_data.data.dropdown.edit_model_column_list;

    let isValid;
    Current_Table_Data.forEach((item) => {
      isValid = TABLE_HEAD_COLUMN_LIST.every((column) => {
        if (column.is_dependent) {
          const Filtered_Dropdown_Data = source_data.data.dropdown[column.name];
          const Parent_Column_Name = column.parent_column;
          const Parent_Column_Value = item.rowData[Parent_Column_Name];

          // CHECK IS VALID VALUE
          const Filtered_Final_Options =
            Parent_Column_Value !== null
              ? Filtered_Dropdown_Data.filter(
                  (option) =>
                    option[Parent_Column_Name] === Parent_Column_Value,
                )
              : [];

          const isValidated = Filtered_Final_Options[0][column.name].includes(
            item.rowData[column.name],
          );

          return isValidated;
        } else {
          let result = EDIT_COLUMN_LIST.find(
            (data) => data.type === "select" && column.name === data.name,
          );

          if (result && result.type === "select") {
            const DROPDOWN_DATA_NEW = source_data.data.dropdown;

            let Final_DropDown_Values;
            EDIT_COLUMN_LIST.map((editItem) => {
              if (editItem.name === column.name && editItem.isArray) {
                Final_DropDown_Values = DROPDOWN_DATA_NEW[column.name];
              }
              if (editItem.name === column.name && !editItem.isArray) {
                const BRONZE_TABLE =
                  Object.keys(DROPDOWN_DATA_NEW[column.name]["BRONZE_TABLE"])
                    .length > 0
                    ? DROPDOWN_DATA_NEW[column.name]["BRONZE_TABLE"][
                        item.rowData[editItem.parent_for_dropdown].toUpperCase()
                      ]
                    : [];

                const HEADER_TABLE =
                  Object.keys(DROPDOWN_DATA_NEW[column.name]["HEADER_TABLE"])
                    .length > 0
                    ? DROPDOWN_DATA_NEW[column.name]["HEADER_TABLE"][
                        item.rowData[editItem.parent_for_dropdown].toUpperCase()
                      ]
                    : [];

                Final_DropDown_Values = [
                  ...(Array.isArray(BRONZE_TABLE) && BRONZE_TABLE.length > 0
                    ? BRONZE_TABLE
                    : []),
                  ...(Array.isArray(HEADER_TABLE) && HEADER_TABLE.length > 0
                    ? HEADER_TABLE
                    : []),
                ];
              }
            });

            // UNCOMMENT IF CASE SENSITIVE TEST IS NOT REQUIRED
            // const isValidated = Array.isArray(Final_DropDown_Values) && Final_DropDown_Values.some((option)=> option.toUpperCase() === item.rowData[column.name].toUpperCase() )

            return (
              Array.isArray(Final_DropDown_Values) &&
              Final_DropDown_Values.includes(item.rowData[column.name])
            );
          } else {
            return true;
          }
        }
      });
    });

    if (isValid) {
      updateAlert({
        open: true,
        message: "File data validated successfully",
        severity: "success",
        closeFlag: true,
      });
      setIsFileUploading(false);
      updateSourceInputs("current_mapped_data", tableData);
      updateSourceInputs("isFileUploaded", true);
    } else {
      updateAlert({
        open: true,
        message: "Validation Failed, Please check the Record and try again",
        severity: "success",
        closeFlag: true,
      });
    }

    setIsFileUploading(false);
  };

  const handleFileUpload = (records) => {
    setIsFileUploading(true);

    const Meta_Filters = source_data.data.dropdown.metadata_filter;
    const Existing_Records = source_data.current_mapped_data;
    const XL_FILE_RECORDS = records.map((item) => {
      return {
        ...item,
        [Meta_Filters[1]]: source_data.current_ssfFileId || "",
        CREATED_AT: item.CREATED_AT || null,
        CREATED_BY: item.CREATED_BY || null,
        UPDATED_AT: item.UPDATED_AT || null,
        UPDATED_BY: item.UPDATED_BY || null,
      };
    });

    const FILTEREDRECORDS = [...XL_FILE_RECORDS, ...Existing_Records];

    let ITEM_ID = 0;
    const tableData =
      FILTEREDRECORDS &&
      FILTEREDRECORDS.map((item) => {
        const rowData = {
          item_Id: ITEM_ID,
          isEditing:
            typeof item.isEditing === "boolean" ? item.isEditing : false,
          isNewData:
            typeof item.isNewData === "boolean" ? item.isNewData : true,
          isEdited: typeof item.isEdited === "boolean" ? item.isEdited : false,
          isValidated:
            typeof item.isValidated === "boolean" ? item.isValidated : true,
          isCheckedRow:
            typeof item.isCheckedRow === "boolean" ? item.isCheckedRow : false,
          errorMessage: "",
          rowData: item.rowData ? item.rowData : item,
        };
        ITEM_ID++;
        return rowData;
      });

    handleValidateFileData(tableData);
  };

  const handleDialogClose = () => {
    if (!isTableDataSaving) {
      setIsSaveDialogOpen(false);
    }
  };

  const handleDialogOpen = () => {
    setIsSaveDialogOpen(true);
  };

  const handleEditAllModalopen = () => {
    setIsEditAllModalOpen(true);
  };

  const handleEditAllModalClose = () => {
    setIsEditAllModalOpen(false);
  };

  const getApprovalData = async () => {
    clearReduxState();
    setLoading(true);
    try {
      const params = new URLSearchParams({
        usecase_name: "RGM_retailer_mapping",
        user_name: user.mail || "",
      });
      const response = await fetch(
        api + `/approval/getapprovaldata?${params}`,
        {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
        },
      );
      // Check if response is OK before trying to parse it
      if (!response.ok) {
        throw new Error(`Unexpected error occured. Please try again later`);
      }

      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      if (!data || !data.data) {
        throw new Error("Unexpected error occured. Please try again later");
      }

      updateSourceInputs("approvalData", data.data);
      updateSourceInputs(
        "approvalTable_Header",
        data?.metadata?.table_headers || [],
      );
    } catch (err) {
      updateAlert({
        open: true,
        message: `Unexpected error occured. Please try again later`,
        severity: "success",
        closeFlag: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleDynamicDialogClose = () => {
    setIsDynamicDialogOpen(false);
  };

  const handleDynamicDialogCancel = () => {
    handleDynamicDialogClose();
    updateSourceInputs("is_initial", true);
    updateSourceInputs("is_table_loading", true);
    setLoading(false);
    setTableLoading(false);
    setIsSearchFilterLoading(false);
  };

  // CONSTANTS
  const SOURCE_DATASET_LIST =
    source_data?.current_mapped_source &&
    source_data?.current_mapped_source.map((data) => {
      return data.toString();
    });

  const SOURCE_DATA_SET_SELECTED =
    SOURCE_DATASET_LIST &&
    SOURCE_DATASET_LIST.map((data) => {
      return { label: data, value: data };
    });

  // USE EFFECTS
  useEffect(() => {
    if (
      source_data.current_category != "" &&
      source_data.current_source != ""
    ) {
      setPage(0);
    }
  }, [source_data.current_source, source_data.current_category]);

  useEffect(() => {
    const fetchData = async () => {
      await getSources();
    };
    fetchData();
  }, []);

  return (
    <>
      <LayoutTopSideBottom match={match}>
        {/* Breadcrumbs and Approval Option */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: is_Approver ? "10px" : "0px",
          }}
        >
          <Breadcrumbs match={match} />
          {is_Approver && (
            <ApprovalButton
              buttonText={
                source_data?.data?.dropdown?.approver_details?.button_text ||
                "Approval"
              }
              getApprovalData={getApprovalData}
              isApproval={isApproval}
              setIsApproval={setIsApproval}
              getSources={getSources}
              isTableDataLoading={
                !source_data.is_initial && source_data.is_table_loading
              }
              any_row_isEditing={source_data?.any_row_isEditing}
              sourceData={source_data}
            />
          )}
        </div>
        {loading ? (
          <Loader />
        ) : isApproval ? (
          <ApprovalTable
            sourceData={source_data}
            user={user}
            login={login}
            updateAlert={updateAlert}
            getApprovalData={getApprovalData}
            usecase_name={"RGM_retailer_mapping"}
          />
        ) : (
          <MetaSearchFilter
            loading={loading}
            setInitial={setInitial}
            setTableLoading={setTableLoading}
            setLoading={setLoading}
            setMappedData={setMappedData}
            setMappedDataCreateNew={setMappedDataCreateNew}
            isSearchFilterLoading={isSearchFilterLoading}
            tableLoading={source_data.is_table_loading}
            updateAlert={updateAlert}
            handleFileUpload={handleFileUpload}
            isFileUploading={isFileUploading}
            requiredColumns={
              source_data?.data?.dropdown?.insert_column_attributes
            }
          />
        )}

        {!source_data.is_initial ? (
          !source_data.is_table_loading ? (
            <>
              <EditableTableRetailer
                initWithoutHead
                page_props={page_props}
                sourceDropdownData={source_data.data.dropdown}
                defaultData={source_data.current_mapped_data}
                checkedRowCount={source_data.checked_rows_count}
                getData={getData}
                fieldsArr={fieldsArr}
                rowsPerPage={rowsPerPage}
                setIsEdit={setIsEdit}
                setGlobalEdit={setGlobalEdit}
                page={page}
                setPage={setPage}
                setRowsPerPage={setRowsPerPage}
                updateSourceHandler={handleSourceInput}
                sourceDatasetSelected={SOURCE_DATA_SET_SELECTED}
                setIsSearchFilterLoading={setIsSearchFilterLoading}
              />

              {/* Action button and disclaimer */}
              <div>
                <div className="disclaimer">
                  {/* GROUP EDIT */}
                  <div>
                    {source_data.checked_rows_count > 1 && (
                      <Button
                        disableFocusRipple
                        style={containedButton}
                        onClick={handleEditAllModalopen}
                        disabled={source_data.checked_rows_count < 1}
                      >
                        Edit Selected
                      </Button>
                    )}
                  </div>

                  {/* DISCLAIMER */}
                  <div>
                    {source_data?.data?.dropdown?.disclaimer_details
                      ?.is_Disclaimer_available &&
                      Array.isArray(
                        source_data?.data?.dropdown?.disclaimer_details
                          ?.disclaimer_text,
                      ) &&
                      source_data.data.dropdown.disclaimer_details
                        .disclaimer_text.length > 0 && (
                        <div style={{ display: "flex" }}>
                          <p
                            style={{
                              margin: "0px",
                            }}
                          >
                            Disclaimer:
                          </p>
                          <ul
                            style={{
                              listStyle:
                                source_data.data.dropdown.disclaimer_details
                                  .disclaimer_text.length > 1
                                  ? "outside"
                                  : "none",
                              margin: "0px",
                              marginLeft:
                                source_data.data.dropdown.disclaimer_details
                                  .disclaimer_text.length > 1
                                  ? "0px"
                                  : "-15px",
                            }}
                          >
                            {source_data.data.dropdown.disclaimer_details.disclaimer_text.map(
                              (text, idx) => (
                                <li key={idx}>{text}</li>
                              ),
                            )}
                          </ul>
                        </div>
                      )}
                  </div>
                </div>

                {/* ACTION BUTTONS */}
                <div className="action-buttons">
                  <Button
                    disableFocusRipple
                    variant="outlined"
                    style={outlinedCNCButton}
                    onClick={() => setIsCancelDialogOpen(true)}
                    disabled={isTableDataSaving}
                  >
                    Cancel
                  </Button>

                  {globalEdit && (
                    <Button
                      disableFocusRipple
                      style={containedButton}
                      onClick={handleDialogOpen}
                      disabled={isTableDataSaving}
                      // disabled={true}
                    >
                      <span>Save</span>
                    </Button>
                  )}
                </div>
              </div>

              {/* SAVE DIALOG */}
              <div>
                <Dialog
                  fullWidth={true}
                  maxWidth={"sm"}
                  open={isSaveDialogOpen}
                  onClose={handleDialogClose}
                >
                  <DialogTitle>Confirmation</DialogTitle>
                  <DialogContent dividers>
                    <DialogContentText>
                      <p style={{ fontSize: "16px", color: "black" }}>
                        The latest changes will be updated. Do you want to
                        continue?
                      </p>
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button
                      disableFocusRipple
                      variant="outlined"
                      style={outlinedCNCButton}
                      onClick={handleDialogClose}
                      disabled={isTableDataSaving}
                    >
                      Cancel
                    </Button>
                    <Button
                      disableFocusRipple
                      style={containedButton}
                      disabled={isTableDataSaving}
                      onClick={onSave}
                      // onClick={
                      //   source_data.has_awaiting_data.has_records
                      //     ? onSaveAwaitingData
                      //     : onSave
                      // }
                    >
                      Continue
                      {isTableDataSaving && <Loader />}
                    </Button>
                  </DialogActions>
                </Dialog>
              </div>

              {/* CANCEL DIALOG */}
              <div>
                <Dialog
                  fullWidth={true}
                  maxWidth={"sm"}
                  open={isCancelDialogOpen}
                  onClose={() => setIsCancelDialogOpen(false)}
                >
                  <DialogTitle>Confirmation</DialogTitle>
                  <DialogContent dividers>
                    <DialogContentText>
                      <p style={{ fontSize: "16px", color: "black" }}>
                        The latest changes will be undone. Do you want to
                        continue?
                      </p>
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button
                      disableFocusRipple
                      variant="outlined"
                      style={outlinedCNCButton}
                      onClick={() => setIsCancelDialogOpen(false)}
                    >
                      Cancel
                    </Button>
                    <Button
                      disableFocusRipple
                      style={containedButton}
                      onClick={cancelFunction}
                    >
                      Continue
                    </Button>
                  </DialogActions>
                </Dialog>
              </div>

              {isEditAllModelOpen && (
                <EditAllModal
                  allRowData={source_data.current_mapped_data}
                  updateSourceInputs={updateSourceInputs}
                  closeModel={handleEditAllModalClose}
                  cancelButtonStyle={outlinedCNCButton}
                  SaveButtonStyle={containedButton}
                  openModel={isEditAllModelOpen}
                  edit_Model_Column_List={
                    source_data.data.dropdown.edit_model_column_list
                  }
                  sourceData={source_data}
                  pageStart={page_props.page * page_props.rowsPerPage}
                  pageEnd={
                    page_props.page * page_props.rowsPerPage +
                    page_props.rowsPerPage
                  }
                  setGlobalEdit={setGlobalEdit}
                  modified_mapped_data={source_data?.modified_mapped_data || []}
                  updateAlert={updateAlert}
                />
              )}
            </>
          ) : (
            <Loader />
          )
        ) : (
          <div style={{ textAlign: "center" }}>
            {/* Choose the above mapping filters */}
          </div>
        )}

        {/* Enable this code if approval needed start ==========> */}
        {/* {
          <DynamicDialog
            openModal={isDynamicDialogOpen}
            closeModel={handleDynamicDialogClose}
            title={"Confirmation"}
            hasCustomCancelButton={true}
            content={
              <p style={{ fontSize: "16px", color: "black", marginTop: "6px" }}>
                {dynamicDialogMessage}
              </p>
            }
            actions={
              <>
                <Button
                  onClick={handleDynamicDialogCancel}
                  style={{
                    fontFamily: "Hind Siliguri",
                    fontSize: "12px",
                    fontWeight: "bold",
                    marginRight: "5px",
                  }}
                >
                  {source_data.has_awaiting_data.has_access ? "Cancel" : "Ok"}
                </Button>
                {source_data.has_awaiting_data.has_access && (
                  <Button
                    onClick={fetchAwaitingRecords}
                    style={{
                      backgroundColor: "#46596A",
                      fontFamily: "Hind Siliguri",
                      fontSize: "12px",
                      fontWeight: "bold",
                      marginRight: "5px",
                      color: "white",
                    }}
                  >
                    fetch
                  </Button>
                )}
              </>
            }
          />
        } */}
        {/* Enable this code if approval needed end =========> */}
      </LayoutTopSideBottom>

      {/* Table view*/}
    </>
  );
}

RGMRetailView.propTypes = {
  updateAlert: PropTypes.func,
};

const mapStateToProps = (state) => ({
  user: state.user,
  source_data: state.source,
});

const mapDispatchToProps = {
  updateAlert,
  updateSourceInputs,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(RGMRetailView),
);
